export enum KeyEventNames {
  BACKSPACE_KEY = 'Backspace',
  LEFT_ARROW_KEY = 'ArrowLeft',
  RIGHT_ARROW_KEY = 'ArrowRight',
  ENTER_KEY = 'Enter',
}
